var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "edit-tag-dialog" }, [
    _c("div", { staticClass: "title" }, [
      _c("span", {
        staticClass: "el-icon-arrow-left",
        on: { click: _vm.back },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("标签管理")]),
      _vm._v(" "),
      _c("span", { staticClass: "el-icon-close rt", on: { click: _vm.close } }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search" },
      [
        _c("el-input", {
          attrs: {
            maxlength: 10,
            size: "mini",
            placeholder: "输入标签名，最多十个字符",
          },
          model: {
            value: _vm.searchInput,
            callback: function ($$v) {
              _vm.searchInput = $$v
            },
            expression: "searchInput",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      _vm._l(_vm.list, function (item, index) {
        return _c("div", { key: index, staticClass: "tag-list" }, [
          _c(
            "span",
            {
              staticClass: "tag-name",
              style: { background: item.color ? item.color : "#ccc" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    item.name.length > 10
                      ? item.name.substring(0, 10) + "..."
                      : item.name
                  ) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "rt" }, [
            _c("span", {
              staticClass: "el-icon-edit",
              on: {
                click: function ($event) {
                  return _vm.editBtn(item)
                },
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "el-icon-delete",
              on: {
                click: function ($event) {
                  return _vm.deleteBtn(item)
                },
              },
            }),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }